import {useList} from "@refinedev/core"
import IAuthentication from "../interfaces/IAuthentication"

export const AUTHENTICATIONS_RESOURCE = 'authentication'

export function getAuthentications() {
    const {data: authenticationsData, isLoading: isAuthenticationsLoading, error: authenticationsError} = useList<IAuthentication>({
        resource: AUTHENTICATIONS_RESOURCE,
        meta: {resourceName: 'authentications'}
    })
    return {authentications: authenticationsData?.data ?? [], isAuthenticationsLoading, authenticationsError}
}
